// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#loading-bar .bar {\n    background: yellow !important;\n    opacity: .75 !important;\n    box-shadow: none !important;\n    height: 1px !important;\n}\n\n#loading-bar .peg {\n    /*box-shadow: yellow 1px 2px 3px !important;*/\n    box-shadow: none !important;\n}\n\n#loading-bar-spinner {\n    display: none !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
